import React, { useState } from "react";
import { BsRobot, BsThreeDotsVertical } from "react-icons/bs";
//libraries
import {
  Button,
  Space,
  Table,
  Tag,
  Modal,
  Tooltip,
  Switch,
  Avatar,
  message,
  Dropdown,
  Menu,
  Input,
  Pagination,
} from "antd";
import {
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlineArrowUp,
  AiOutlineCode,
} from "react-icons/ai";
import { CopyOutlined, SyncOutlined } from "@ant-design/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DebouncedSearchInput from "../../Pages/SuperAdmin/Organizations/DebouncedSearchInput";
import { SEARCH_ALL_USER_CREATED_ASSISTANTS_SLUG } from "../../constants/Api_constants";
import { axiosSecureInstance } from "../../api/axios";
import { useEffect } from "react";
import { getUserID } from "../../Utility/service";
import {
  handleSwitchChange,
  showDeleteConfirm,
  showRemoveConfirm,
} from "../../Utility/showModalHelper";
import "./Assistant.css";
import { handleCheckAssistantActive } from "../../Utility/addPublicAssistantHelper";
import { FileContext } from "../../contexts/FileContext";
import { useContext } from "react";
import { BiSolidLock, BiSolidLockOpen } from "react-icons/bi";
import { IoChatbubbleEllipsesOutline, IoCloseCircle } from "react-icons/io5";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { generateEmbedCode } from "../../constants/Api_constants";
import ProfileHeader from "../Proflie/ProfileHeader";
import { RxCrossCircled } from "react-icons/rx";
import { CiCircleCheck } from "react-icons/ci";
const { confirm } = Modal;

const AdminAssistantList = ({ data }) => {
  const {
    setAdminUserAssistants,
    adminUserAssistants,
    loader,
    handleDeleteAssistant,
    handleUpdateAssistant,
    showEditModalHandler,
    handleFetchUserCreatedAssistants,
    totalCount,
    updateLoader,
    searchPersonalAssistants,
    personalAssistantSearchQuery,
    setPersonalAssistantSearchQuery,
    handlePublicAssistantAdd,
    getAssistantInfo,
  } = data;

  const [searchQuery, setSearchQuery] = useState("");
  const [isPublic, setIsPublic] = useState(false);
  const { isEditPageLoading, setIsEditPageLoading } = useContext(FileContext);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const redirectToAssistant = (record) => {
    const assistantId = record.assistant_id;
    const url = `/agents/${assistantId}`;
    window.open(url, "_blank");
  };

  const redirectToCustomEmbed = (record) => {
    const assistantId = record.assistant_id;
    const url = `/customize-embed-code/${assistantId}`;
    window.open(url, "_blank");
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [copied, setCopied] = useState(false);
    const baseURL = process.env.REACT_APP_FE_URL;

    const openModal = (record) => {
        setSelectedRecord(record);
        setIsModalVisible(true);
    };

    const handleCopy = () => {
        setCopied(true);
        message.success("Embed code copied!");
        setTimeout(() => setCopied(false), 2000);
    };

  useEffect(() => {
    handleFetchUserCreatedAssistants(
      currentPage,
      personalAssistantSearchQuery,
      pageSize
    );
  }, [currentPage, personalAssistantSearchQuery, pageSize]);

  const navigateToCustomizationPage = (assistantName, assistantId) => {
    navigate(`/customize-embed-code/${assistantId}`);
  };

  const showDeleteConfirm = (assistantId, assistantName) => {
    confirm({
      title: "Are you sure delete this Agent?",
      content: `You are deleting ${assistantName}.`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDeleteAssistant(
          assistantId,
          currentPage,
          personalAssistantSearchQuery,
          pageSize
        );
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const createActionMenu = (record) => {
    return (
      <Menu>
        {
          <Menu.Item key="chat">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => redirectToAssistant(record)}
            >
              <IoChatbubbleEllipsesOutline /> Chat with Agent
            </span>
          </Menu.Item>
        }
        
        {
          <Menu.Item key="edit">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                setIsEditPageLoading(true);
                const isExisting = await getAssistantInfo(record?.assistant_id);
                if (isExisting) {
                  await showEditModalHandler(record);
                  // Fetch assistants after editing
                  handleFetchUserCreatedAssistants(
                    currentPage,
                    personalAssistantSearchQuery,
                    pageSize
                  );
                } else {
                  setIsEditPageLoading(false);
                }
              }}
            >
              <AiOutlineEdit /> Edit Agent
            </span>
          </Menu.Item>
        }

        {
          <Menu.Item key="activate">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                await handleSwitchChange(
                  record,
                  !record?.is_active,
                  handleUpdateAssistant
                );
                // Refetch assistants
                handleFetchUserCreatedAssistants(
                  currentPage,
                  personalAssistantSearchQuery,
                  pageSize
                );
              }}
            >
              {record?.is_active ? <RxCrossCircled /> : <CiCircleCheck />} Make{" "}
              {record?.is_active ? "Deactivate" : "Activate"}
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="public">
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={async () => {
                await handleCheckAssistantActive(
                  !record?.is_public,
                  record,
                  handlePublicAssistantAdd
                );
                handleFetchUserCreatedAssistants(
                  currentPage,
                  personalAssistantSearchQuery,
                  pageSize
                );
              }}
            >
              {record?.is_public ? <BiSolidLock /> : <BiSolidLockOpen />} Make{" "}
              {record?.is_public ? "Private" : "Public"}
            </span>
          </Menu.Item>
        }
        {
          <Menu.Item key="embed">
          <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => openModal(record)}
          >
              <IoChatbubbleEllipsesOutline /> Generate Embedded Code
          </span>
        </Menu.Item>
  
        }
        {
          <Menu.Item key="embed">
          <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() => redirectToCustomEmbed(record)}
          >
              <AiOutlineCode /> Get Custom Embedded Code
          </span>
        </Menu.Item>
  
        }
        {
          <Menu.Item key="delete" danger>
            <span
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={() =>
                showDeleteConfirm(
                  record?.assistant_id,
                  record?.name,
                  handleDeleteAssistant
                )
              }
            >
              <AiOutlineDelete /> Delete
            </span>
          </Menu.Item>
        }
      </Menu>
    );
  };

  const columns = [
    {
      title: "Agent",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (_, { name, image_url }) => (
        <Space size="middle" className="d-flex align-items-center">
          <div className="assistantImageDiv">
            {image_url ? (
              <img src={image_url} className="customImage" alt="avatar" />
            ) : (
              <BsRobot className="customImage" />
            )}
          </div>
          <div className="ms-2 text-start">{name}</div>
        </Space>
      ),
    },
    {
      title: "Status",
      key: "is_active",
      align: "center",
      dataIndex: "is_active",
      width: 100,
      render: (_, { is_active }) => (
        <Tag color={is_active ? "green" : "red"}>
          {is_active ? "active" : "inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={createActionMenu(record)} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <BsThreeDotsVertical />
              </Space>
            </a>
          </Dropdown>
          {/* <Button
            onClick={() => redirectToAssistant(record)}
            icon={<AiOutlineArrowUp />}
          ></Button>

          <Button
            onClick={async() => {
              setIsEditPageLoading(true);
              const isExisting = await getAssistantInfo(record?.assistant_id);
              if(isExisting){
                await showEditModalHandler(record);
              }else{
                setIsEditPageLoading(false);

              }
            
            }}
            icon={<AiOutlineEdit /> } 
          >

          </Button>
          <Tooltip title="Activate or Deactivate">
            <Switch
              checked={record?.is_active}
              onChange={async (checked) =>

                await handleSwitchChange(record, checked, handleUpdateAssistant)

              }
              loading={
                loader.ASSISTANT_UPDATING === record._id ?? false
              }

            />
          </Tooltip>
          <Button
            onClick={() => showDeleteConfirm(record?.assistant_id, record?.name,handleDeleteAssistant)}
            danger
            icon={<AiOutlineDelete />}
            loading={
              loader.ASSISTANT_DELETING === record._id
            }

          />
          <Tooltip title="Public or Private">
            <Switch
              checked={record?.is_public}
              onChange={(checked) =>{handleCheckAssistantActive(checked, record, handlePublicAssistantAdd)}
              }
              loading={
                loader.ASSISTANT_UPDATING === record._id ?? false
              }

            />
          </Tooltip> */}
        </Space>
      ),
    },
  ];

  return (
    <>
    <Modal
                title="Full Embed Code"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
            >
                {selectedRecord && (
                    <>
                        <Input.TextArea
                            value={generateEmbedCode(selectedRecord, baseURL)}
                            readOnly
                            autoSize={{ minRows: 3, maxRows: 6 }}
                        />
                        <CopyToClipboard text={generateEmbedCode(selectedRecord, baseURL)} onCopy={handleCopy}>
                            <Button type="primary" style={{ marginTop: "10px", width: "100%" }}>
                                {copied ? "Copied!" : "Copy Embed Code"}
                            </Button>
                        </CopyToClipboard>
                    </>
                )}
            </Modal>
      <div className="mb-3">
        <ProfileHeader title="My Agents" subHeading="List of agents created by you." />
          <div className="searchbox-container">
          <div className="searchbox-wrapper">
            <DebouncedSearchInput
              data={{
                search: personalAssistantSearchQuery,
                setSearch: setPersonalAssistantSearchQuery,
                placeholder: "Search agents",
              }}
            />
          </div> 
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalCount}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
          />
        </div>
      </div>
      <Table
        loading={loader.ASSISTANT_LOADING || isEditPageLoading}
        columns={columns}
        dataSource={adminUserAssistants}
        scroll={{ y: "50vh" }}
        className={`${(loader.ASSISTANT_LOADING || isEditPageLoading || adminUserAssistants?.length === 0) ? "mt-2" : ""}`}
        pagination={false}
      />
    </>
  );
  
};

export default AdminAssistantList;
